
import { defineComponent, computed } from "vue";
import { useI18n } from "vue-i18n";
import { ContentLoader } from "vue-content-loader";
import { CalculationResponse } from "@/interfaces/CalculationResponse";
import { getCarSizeTranslation } from "@/i18n";

export default defineComponent({
  name: "Costs",
  props: {
    costs: {
      type: Object as () => CalculationResponse,
      default: null,
    },
    loading: {
      type: Boolean,
      default: true,
    },
    error: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: "",
    },
  },
  emits: ["previousStep", "subscribe"],
  components: { ContentLoader },
  setup(props, { emit }) {
    const i18n = useI18n();

    const cons = computed(() => {
      let cons = [];
      let count = 1;
      let con = i18n.t("own-car-cheaper-body-con-" + count.toString());
      while (!con.startsWith("own-car-cheaper-body-con-")) {
        cons.push(con);
        count++;
        con = i18n.t("own-car-cheaper-body-con-" + count.toString());
      }
      return cons;
    });

    function previousStep(clickEvent: Event) {
      clickEvent.preventDefault();
      emit("previousStep");
    }

    function subscribe(clickEvent: Event) {
      clickEvent.preventDefault();
      emit("subscribe");
    }

    return {
      getCarSizeTranslation,
      previousStep,
      subscribe,
      cons,
    };
  },
});
